<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <div>
      <v-alert
        :type="alert_type"
        :model-value="alert"
        :value="alert"
        transition="scale-transition"
        >{{ alert_message }}</v-alert
      >
    </div>

    <div><HeaderComponent :headerTitle="headerText" /></div>
    <v-tabs color="primary">
      <v-tab
        ripple
        style="text-transform: none !important"
        @click="loadData(tab)"
        v-for="(tab, index) in tabs"
        :key="index"
        >{{ tab }}</v-tab
      >
    </v-tabs>

    <!--Success Submit confirm popup -->
    <v-row justify="center" class="m-0">
      <v-dialog v-model="submitPopup" persistent max-width="424px">
        <v-card class="v-card-100 pa-2">
          <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="submitConfirmationCancel">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <span> {{ message }} </span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="primary" variant="flat" class="mb-3" @click="afterSubmitLoadData"
              >Ok</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Edit Document Popup -->
    <v-row justify="center" class="m-0">
      <v-dialog v-model="editPopup" persistent max-width="700px">
        <v-card class="v-card-100">
            <v-card-title class="d-flex align-center">
              <span>Inbound Documents</span>
              <v-spacer></v-spacer>
              <v-btn variant='solo' icon @click="closeEditPopup">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
          <v-divider :thickness="4" class="m-0"/>
          <v-card-text style="padding-bottom: 0px !important">
            <v-container>
              <v-row>
                <v-col cols="12" sm="5" md="6">
                  <v-text-field
                    color="primary"
                    variant="outlined"
                    label="Document Number"
                    v-model="doc_number"
                    :error-messages="isDocNotExsit ? [ErrorMessages1] : []"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="5" md="6">
                  <v-text-field
                    color="primary"
                    variant="outlined"
                    label="Article ID"
                    v-model="articleId"
                    :error-messages="isNotMatch ? [ErrorMessages2] : []"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn
              variant="outlined"
              color="primary"
              class="cancel-color mb-3"
              @click="closeEditPopup"
              >Cancel</v-btn
            >
            <v-btn
              :color="doc_number == '' || articleId == '' ? '' : 'primary'"
              :disabled="doc_number == '' || articleId == ''"
              class="mb-3"
              variant="flat"
              @click="proceedEditPopup"
              >Proceed</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Edit Document  Proceed Popup -->
    <v-row justify="center" class="m-0">
      <v-dialog v-model="proceedPopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Inbound Documents</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="closeProceedPopup">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0"/>
          <v-card-text style="padding-bottom: 0px !important">
            <v-container>
              <v-row>
                <v-col cols="12" sm="5" md="6">
                  <v-text-field
                    color="primary"
                    disabled
                    variant="outlined"
                    label="Document Number"
                    v-model="doc_number"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="5" md="6">
                  <v-text-field
                    color="primary"
                    variant="outlined"
                    disabled
                    label="Article ID"
                    v-model="articleId"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="5" md="6">
                  <v-text-field
                    color="primary"
                    disabled
                    variant="outlined"
                    label="Article Description"
                    v-model="article_descip"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="5" md="6">
                  <v-autocomplete
                    color="primary"
                    variant="outlined"
                    label="Scan Indicator"
                    v-model="scanIndicator"
                    :items="yesNoList"
                    @change="makeDisableImeiAndSerial"
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="5" md="6">
                  <v-combobox
                    :disabled="scanIndicator == 'No'"
                    variant="outlined"
                    label="IMEI Flag"
                    v-model="imeiFlag"
                    :items="imeiList"
                    @change="updateSerialNumber"
                  >
                  </v-combobox>
                </v-col>
                <v-col cols="12" sm="5" md="6">
                  <v-text-field
                    :disabled="scanIndicator == 'No' || imeiFlag != '0'"
                    variant="outlined"
                    label="Serial Number Length"
                    v-model="serialNumbLength"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn
              variant="outlined"
              color="primary"
              class="cancel-color mb-3"
              @click="closeProceedPopup"
              >Cancel</v-btn
            >
            <v-btn color="primary" variant="flat" class="mb-3" @click="submitProceedPopup"
              >Submit</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-card-title>
      <v-row class="m-0">
        <v-col cols="3" sm="3">
          <v-select
            :items="field_item"
            v-model="field_type"
            item-value="value"
            item-title="name"
            label="Select Field"
            variant="outlined"
            color="primary"
          ></v-select>
        </v-col>
        <v-col cols="6" sm="6">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            v-model="search"
            label="Search Document Number, Source, Destination Code, Assigned Username"
            variant="outlined"
            color="primary"
            v-on:keyup.enter="searchItem()"
          ></v-text-field>
        </v-col>
        <v-col cols="3" sm="3">
          <div class="editDocument">
            <v-btn color="primary" @click="openEditPopup">Edit Document</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card-title>

    <!-- Document Detail popup Start-->
    <v-row justify="center" class="m-0">
      <v-dialog
        v-model="documentDetailDialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card class="mt-0">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Document Details</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-card-actions>
              <v-btn variant='solo' icon dark class="text-white bg-primary" @click="closeDocumentInformationDialog"
                ><v-icon color="white">mdi-close</v-icon></v-btn
              >
            </v-card-actions>
          </v-toolbar>

          <v-list-item-content class="pa-0">
            <v-toolbar color="#EDF3FA" height="53">
              <v-tabs v-model="tab_link_index">
                <v-tab
                  @click="loadDetails(tab_link)"
                  v-for="(tab_link, index) in DocumentInformationTabs"
                  :key="index"
                  >{{ tab_link }}</v-tab
                >
              </v-tabs>
            </v-toolbar>
          </v-list-item-content>

          <v-list-item-content
            class="pl-4"
            v-if="active_details_tab === 'Item List'"
          >
            <v-card>
              <div>
                <v-data-table
                  hover
                  style="overflow-x: auto"
                  :dense="false"
                  :headers="item_information_header"
                  :items="selected_document_data"
                  class="elevation-1"
                >
                </v-data-table>
              </div>
            </v-card>
          </v-list-item-content>

          <v-list-item-content
            class="pl-4"
            v-if="active_details_tab === 'Unassign User'"
          >
            <v-card>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" class="pa-0 pb-3">
                      <v-autocomplete
                        v-model="user"
                        :items="users"
                        item-title="username"
                        item-value="id"
                        placeholder="Select User"
                        prepend-icon="mdi-magnify"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn size="small" variant="flat" color="primary" @click="assignUser()"
                  >Assign User</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-list-item-content>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Document Detail popup Ends -->

    <v-layout column>
      <v-col cols="12" style="overflow: auto" class="p-0">
        <v-data-table
          hover
          density="compact"
          v-model="selected"
          :headers="headers"
          :items="table_data"
          show-select
          class="elevation-1"
          :loading="loading"
          :custom-sort="customSort"
          :items-per-page='pageSize'
          disable-pagination
          :hide-default-footer="true"
          loading-text="Loading Data... Please wait"
          return-object
        >
          <template v-slot:item.dispatch_date="{ item }">
            {{ format_date(item.dispatch_date) }}
          </template>

          <template v-slot:item.document_submitted_time="{ item }">
            {{ format_date(item.document_submitted_time) }}
          </template>

          <template v-slot:item.view_items="{ item }">
            <img
              @click="viewDocumentDetails(item)"
              src="@/assets/images/job_sheet.png"
              title="View Items"
            />
          </template>
          <template #bottom></template>
        </v-data-table>
      </v-col>
    </v-layout>
    <div>
      <v-row class="ml-2 pb-0">
        <v-col cols="3" sm="3" class="PaddingItemPerPage d-flex mt-3">
          <label class="" style="margin-top: -2px;">Rows Per Page</label>
          <v-select v-model="pageSize" :items="pageSizes" class="custom-pagination-ui" @update:modelValue="handlePageSizeChange"
            variant="outlined" style="width: 40px;margin-left: 120px;margin-top:-10px;position:absolute;"></v-select>
        </v-col>
        <span class="item-selected"> <span v-if="selected.length == 1">{{ selected.length }} Item Selected</span> <span
            v-if="selected.length > 1">{{ selected.length }} Items Selected</span> </span>
        <v-spacer></v-spacer>
        <span class="pt-3 mt-3 mr-7" v-if="this.totalCount > 0">Showing Results {{ (this.page - 1) * this.pageSize + 1 }}
          - {{ Math.min(this.page * this.pageSize, this.totalCount) }} of {{ this.totalCount }}</span>
        <v-col cols="2" sm="2" class="PaddingItemPerPage custom-column-ui">
          <v-pagination v-model="page" :length="totalPages" total-visible="7" class="custom-pagination-ui"
          @update:modelValue="handlePageChange" circle></v-pagination>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<style scoped>
.theme--light.v-icon {
  color: #1867c0 !important;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  font-size: 14px !important;
}
/* .v-card {
  max-width: 97% !important;
} */

.v-card-100 {
  max-width: 100% !important;
}
.v-dialog__content:has(.filter-data) {
  justify-content: right;
  align-items: baseline;
  top: 15rem;
}
.editDocument {
  display: flex;
  justify-content: right;
  margin-top: 8px;
}
</style>

<script>
import HeaderComponent from "./../../../commoncomponents/HeaderComponent";
import moment from "moment";
export default {
  data() {
    return {
      headerText: "Inbound Documents",
      loading: true,
      alert: false,
      alert_type: "success",
      alert_message: "success",
      active_tab: "IBD",
      selected_document_data: [],
      DocumentInformationTabs: ["Item List", "Unassign User"],
      item_information_header: [],
      documentDetailDialog: false,
      user: "",
      active_details_tab: "Item List",
      tab_link_index: 0,
      selected_row: [],
      users: [],
      tabs: ["IBD", "OBD", "GI"],
      singleSelect: false,
      selected: [],
      search: "",
      menu_items: [],
      dialog: false,
      proceedPopup: false,
      editPopup: false,
      articleId: "",
      doc_number: "",
      article_descip: "",
      scanIndicator: "",
      yesNoList: ["Yes", "No"],
      imeiList: [0, 1, 2],
      imeiFlag: "",
      serialNumbLength: "",
      isPresent: false,
      ErrorMessages2: "Article ID doesn't matched",
      ErrorMessages1: "Document Number not exist!",
      isNotMatch: false,
      isDocNotExsit: false,
      submitPopup: false,
      message: "",
      headers: [
        {
          title: "Document Number",
          align: "start",
          key: "client_gatepass_number",
        },
        { title: "Dispatch Date", key: "dispatch_date" },
        { title: "Source Code", key: "vendor_code" },
        { title: "Destination Code", key: "destination_code" },
        { title: "Assigned Username", key: "assigned_username", width: "10%" },
        { title: "Status", key: "status", width: "10%" },
        { title: "Is Scanned", key: "is_scanned" },
        { title: "Pushed to SAP", key: "is_scanned" },
        { title: "Is Error", key: "is_error" },
        { title: "Action", key: "view_items" },
      ],
      inventory_details_header: [
        { title: "Item Number", key: "item_number", width: "6%" },
        { title: "Article", key: "sku_code" },
        { title: "Article Description", key: "sku_description", width: "10%" },
        { title: "Category", key: "category_code", width: "6%" },
        { title: "EAN", key: "ean" },
        { title: "Serial Number", key: "serial_number" },
        { title: "IMEI1", key: "imei1" },
        { title: "IMEI2", key: "imei2" },
        { title: "Expected Qyy", key: "quantity", width: "4%" },
        { title: "Scan Qty", key: "inwarded_quantity", width: "4%" },
        { title: "Scan Ind", key: "scan_id", width: "4%" },
        { title: "Short Qty", key: "short_quantity", width: "4%" },
        { title: "Short Reason", key: "short_reason" },
        { title: "Pickslip Number", key: "pickslip_number" },
        { title: "Scanned Time", key: "scanned_time" },
        { title: "Synced Time", key: "synced_time" },
        { title: "BB Document Received Time", key: "document_submitted_time" },
        { title: "SAP Document Pushed Time", key: "pushed_at" },
      ],
      table_data: [],
      page: 1,
      totalPages: 1,
      pageSize: 100,
      pageSizes: [100, 200, 500],
      totalCount: '',
      field_item: [
        { name: "Document Number", value: "client_gatepass_number" },
        { name: "Source Code", value: "source_code" },
        { name: "Destination Code", value: "destination_code" },
        { name: "Assigned Username", value: "assigned_username" },
      ],
      field_type: null,
      alert_value: "",
      alert_item: [
        { name: "All", value: "" },
        { name: "High", value: "high" },
        { name: "Medium", value: "medium" },
        { name: "Low", value: "low" },
      ],
    };
  },
  created() {
    this.getDocumentData("IBD");
    this.getUserList();
  },
  components: {
    HeaderComponent,
  },
  watch: {
    dispatchDialog() {
      this.$refs.dispatchForm.reset();
    },
  },
  methods: {
    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },

    format_date(value) {
      if (value) {
        return moment(String(value)).format("DD-MM-YYYY");
      }
    },

    assignUser() {
      this.$httpSecured
        .get("/api/v1/warehouse/wms/documents/assign_user", {
          params: { id: this.user, document_id: this.selected[0].id },
        })
        .then((response) => {
          if (response && response.data) {
            this.selected[0].assigned_username =
              response.data.gate_pass.assigned_username;
            this.selected[0].assigned_user_id =
              response.data.gate_pass.assigned_user_id;
            this.user = response.data.gate_pass.assigned_user_id;
            this.closeDocumentInformationDialog();
            this.showAlert(
              "success",
              "User for this document assigned successfully",
            );
          } else {
            this.showAlert("error", "Error in assigning user");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
        });
    },

    getUserList() {
      this.$httpSecured
        .get("/api/v1/warehouse/wms/documents/users_list")
        .then((response) => {
          if (response && response.data) {
            this.users = response.data.users;
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
        });
    },

    getRequestParams(page, pageSize) {
      let params = {};

      if (page) {
        params["page"] = page;
      }

      if (pageSize) {
        params["size"] = pageSize;
      }

      return params;
    },

    closeDocumentInformationDialog() {
      this.documentDetailDialog = false;
      this.selected = [];
      this.selected_document_data = [];
      this.user = "";
    },

    viewDocumentDetails(item) {
      this.selected_document_data = [];
      this.tab_link_index = 0;
      this.active_details_tab = "Item List";
      this.item_information_header = this.inventory_details_header;
      this.documentDetailDialog = true;
      this.selected.push(item);
      this.$httpSecured
        .get("/api/v1/warehouse/wms/documents/get_item_list", {
          params: { id: item.id },
        })
        .then((response) => {
          if (response && response.data.gate_pass_inventories != undefined) {
            this.selected_document_data = response.data.gate_pass_inventories;
            this.user = item.assigned_user_id;
          } else if (response && response.data.inventories != undefined) {
            this.selected_document_data = response.data.inventories;
            this.user = item.assigned_user_id;
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
        });
    },

    loadDetails(tab_link) {
      this.active_details_tab = tab_link;
      if (tab_link == "Inventory Details") {
        this.lot_information_header = this.inventory_details_header;
        this.selected_lot_data = this.selected_lot_inventories;
      }
    },

    showAlert(alert_type, alert_message) {
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.alertTimeOut();
    },

    handlePageChange(value) {
      this.page = value;
      this.getDocumentData(this.active_tab);
    },

    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.getDocumentData(this.active_tab);
    },

    getDocumentData(tab) {
      var document_type = ''
      if (tab == "IBD") {
         document_type = "IBD";
      } else if (tab == "OBD") {
         document_type = "OBD";
      } else if (tab == "GI") {
         document_type = "GI";
      }
      this.loading = true;
      const params = this.getRequestParams(this.page, this.pageSize);
      var status = this.getStatus(tab);
      this.$httpSecured
        .get("/api/v1/warehouse/wms/documents", {
          params: {
            page: params["page"],
            per_page: params["size"],
            status: status,
            document_type: document_type,
          },
        })
        .then((response) => {
          if (response.data) {
            this.original_table_data = response.data.gate_passes;
            this.totalPages = response.data.meta.total_pages;
            this.totalCount =  response.data.meta.total_count
            this.table_data = this.original_table_data;
            // this.table_data = this.original_table_data.filter(
            //   x => x.status == status
            // ).map(function(inv_item){inv_item.both_ageing = {ageing_dispatch:inv_item.ageing_dispatch, ageing_inward:inv_item.ageing}; return inv_item});
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },

    getStatus(tab) {
      var status = "";
      if (tab == "Pending Call Log") {
        status = "Pending Claim";
      } else if (tab == "Update Call Log") {
        status = "Pending Call Log";
      } else if (tab == "Pending Inspection") {
        status = "Pending Brand Inspection";
      } else if (tab == "Pending Brand Resolution") {
        status = "Pending Brand Approval";
      } else {
        status = tab;
      }
      return status;
    },

    loadData(tab) {
      this.selected = [];
      this.active_tab = tab;
      this.table_data = [];
      this.search = "";
      this.page = 1;
      this.totalPages = 1;
      this.pageSize = 100;
      this.field_type = null;
      var status = this.getStatus(tab);

      this.getDocumentData(tab);

      const filteredData = this.original_table_data
        .filter((x) => x.status == status)
        .map(function (inv_item) {
          inv_item.both_ageing = {
            ageing_dispatch: inv_item.ageing_dispatch,
            ageing_inward: inv_item.ageing,
          };
          return inv_item;
        });
      this.table_data = filteredData;

      if (tab == "IBD") {
        this.headers = [
          {
            title: "Document Number",
            align: "start",
            sortable: false,
            key: "client_gatepass_number",
          },
          { title: "Dispatch Date", key: "dispatch_date" },
          { title: "Source Code", key: "vendor_code" },
          { title: "Destination Code", key: "destination_code" },
          {
            title: "Assigned Username",
            key: "assigned_username",
            width: "10%",
          },
          { title: "Status", key: "status", width: "10%" },
          { title: "Is Scanned", key: "is_scanned" },
          { title: "Pushed to SAP", key: "is_scanned" },
          { title: "Is Error", key: "is_error" },
          { title: "Action", key: "view_items" },
        ];
      }

      if (tab == "OBD") {
        this.headers = [
          {
            title: "Document Number",
            align: "start",
            sortable: false,
            key: "client_gatepass_number",
          },
          { title: "Dispatch Date", key: "dispatch_date" },
          { title: "Source Code", key: "source_code" },
          { title: "Destination Code", key: "destination_code" },
          {
            title: "Assigned Username",
            key: "assigned_username",
            width: "10%",
          },
          { title: "Status", key: "status", width: "10%" },
          { title: "Is Scanned", key: "is_scanned" },
          { title: "Pushed to SAP", key: "is_scanned" },
          { title: "Is Error", key: "is_error" },
          { title: "Action", key: "view_items" },
        ];
      }

      if (tab == "GI") {
        this.headers = [
          {
            title: "Document Number",
            align: "start",
            sortable: false,
            key: "client_gatepass_number",
          },
          { title: "Dispatch Date", key: "dispatch_date" },
          { title: "Source Code", key: "source_code" },
          { title: "Destination Code", key: "destination_code" },
          {
            title: "Assigned Username",
            key: "assigned_username",
            width: "10%",
          },
          { title: "Status", key: "status", width: "10%" },
          { title: "Is Scanned", key: "is_scanned" },
          { title: "Pushed to SAP", key: "is_scanned" },
          { title: "Is Error", key: "is_error" },
          { title: "Action", key: "view_items" },
        ];
      }
    },

    searchItem() {
      const params = this.getRequestParams(this.page, this.pageSize);
      if (!this.field_type) {
        this.showAlert("error", "Please Select Field to search in");
        return;
      }

      var status = this.getStatus(this.active_tab);
      var document_type =''
      if (this.active_tab == "IBD") {
         document_type = "IBD";
      } else if (this.active_tab == "OBD") {
         document_type = "OBD";
      } else if (this.active_tab == "GI") {
         document_type = "GI";
      }

      const formData = new FormData();

      formData.append("search", this.search);
      formData.append("search_in", this.field_type);
      formData.append("status", status);
      formData.append("document_type", document_type);
      formData.append("page", 1);
      formData.append("per_page", params["size"]);

      if (this.search.length != 0) {
        this.$httpSecured
          .post("/api/v1/warehouse/wms/documents/search_documents", formData)
          .then((response) => {
            if (response.data.gate_passes) {
              this.table_data = response.data.gate_passes;
              this.totalPages = response.data.meta.total_pages;
              this.totalCount =  response.data.meta.total_count
            } else {
              this.showAlert("error", "No Records Found for given value");
            }
          })
          .catch((error) =>
            this.showAlert("error", "Error in fetching Vendor Master"),
          );
      } else {
        this.field_type = null;
        this.getDocumentData(this.active_tab);
      }
    },

    customSort: function (items, index, isDesc) {
      items.sort((a, b) => {
        if (index[0] == "both_ageing") {
          if (!isDesc[0]) {
            return (
              parseInt(b.ageing_dispatch.split(" ")[0]) -
              parseInt(a.ageing_dispatch.split(" ")[0])
            );
          } else {
            return (
              parseInt(a.ageing_dispatch.split(" ")[0]) -
              parseInt(b.ageing_dispatch.split(" ")[0])
            );
          }
        } else {
          if (typeof a[index] !== "undefined") {
            if (!isDesc[0]) {
              return a[index]
                .toLowerCase()
                .localeCompare(b[index].toLowerCase());
            } else {
              return b[index]
                .toLowerCase()
                .localeCompare(a[index].toLowerCase());
            }
          }
        }
      });
      return items;
    },
    openEditPopup() {
      this.editPopup = true;
      this.isNotMatch = false;
      this.isDocNotExsit = false;
    },
    closeEditPopup() {
      this.editPopup = false;
      this.articleId = "";
      this.doc_number = "";
    },
    proceedEditPopup() {
      this.isNotMatch = false;
      this.isDocNotExsit = false;
      const params = {
        document_number: this.doc_number,
        article_id: this.articleId,
      };
      this.$httpSecured
        .get("/api/v1/warehouse/wms/documents/fetch_inbound_record", { params })
        .then((response) => {
          if (response.data) {
            if (response.data.error) {
              if (!response.data.error.includes("Article")) {
                this.isDocNotExsit = true;
                this.ErrorMessages1 = response.data.error;
              } else {
                this.isNotMatch = true;
                this.ErrorMessages2 = response.data.error;
              }
            } else {
              this.proceedPopup = true;
              this.editPopup = false;
              this.inboundId = response.data.id;
              this.article_descip = response.data.item_description;
              this.scanIndicator = response.data.scan_id;
              this.imeiFlag = response.data.imei_flag;
              this.serialNumbLength = response.data.serial_number_length;
              if (response.data.scan_id == "N") {
                this.scanIndicator = "No";
                this.imeiFlag = "N/A";
                this.serialNumbLength = "N/A";
              } else {
                this.scanIndicator = "Yes";
                this.serialNumbLength =
                  this.imeiFlag != 0 ? "N/A" : this.serialNumbLength;
              }
            }
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    closeProceedPopup() {
      this.proceedPopup = false;
      this.articleId = "";
      this.doc_number = "";
      this.article_descip = "";
      this.scanIndicator = "";
      this.imeiFlag = "";
      this.serialNumbLength = "";
      this.isNotMatch = false;
      this.isDocNotExsit = false;
    },
    submitProceedPopup() {
      const scan_id = this.scanIndicator == "No" ? "N" : "Y";
      this.imeiFlag = this.imeiFlag == "N/A" ? "0" : this.imeiFlag.toString();
      this.serialNumbLength =
        this.serialNumbLength == "N/A" ? 0 : parseInt(this.serialNumbLength);
      const id = this.inboundId;
      const gate_pass = {
        scan_id: scan_id,
        imei_flag: this.imeiFlag,
        serial_number_length: this.serialNumbLength,
      };
      this.$httpSecured
        .post(
          "/api/v1/warehouse/wms/documents/update_inbound_scan_flag?id=" + id,
          { gate_pass: gate_pass },
        )
        .then((response) => {
          if (response.data) {
            this.closeProceedPopup();
            this.submitPopup = true;
            this.message = response.data.message;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    makeDisableImeiAndSerial() {
      if (this.scanIndicator == "No") {
        this.imeiFlag = "N/A";
        this.serialNumbLength = "N/A";
      } else {
        this.imeiFlag = "";
      }
    },
    updateSerialNumber() {
      if (this.imeiFlag != 0) {
        this.serialNumbLength = "N/A";
      } else {
        this.serialNumbLength = 0;
      }
    },
    submitConfirmationCancel() {
      this.submitPopup = false;
    },
    afterSubmitLoadData() {
      this.submitPopup = false;
      this.loadData(this.active_tab);
    },
  },

  filters: {
    truncate: function (text, length, suffix) {
      if (text ? text.length : length < 0) {
        return text.substring(0, length) + suffix;
      } else {
        return text;
      }
    },
  },
};
</script>
